// El equipo financiado con el IMEI que ya quedó en el contrato: referencia de solo lectura para
// cotejar contra la caja antes de instalar el candado.
import { Check, Smartphone } from 'lucide-react';
import { StatusPill } from '@/shared/patterns/Pills';

export function FinancedDeviceStrip({ name, imei }: { name: string; imei: string }) {
    return (
        <div
            data-testid="delivery-financed-device"
            className="flex flex-wrap items-center justify-between gap-x-4 gap-y-2.5 rounded-[10px] border border-border bg-muted/50 px-3.5 py-3"
        >
            <div className="flex min-w-0 items-center gap-2.5">
                <span className="flex size-8 flex-none items-center justify-center rounded-lg border border-border bg-card">
                    <Smartphone className="size-4" aria-hidden />
                </span>
                <div className="min-w-0">
                    <div className="text-[13px] font-semibold">{name}</div>
                    <div className="font-mono text-[12.5px] tracking-[0.05em] text-muted-foreground tabular-nums">
                        IMEI {imei}
                    </div>
                </div>
            </div>
            <StatusPill tone="success" className="gap-1 px-2 py-0.5 text-[11px] font-semibold">
                <Check className="size-3" strokeWidth={3} aria-hidden /> Registrado en la firma
            </StatusPill>
        </div>
    );
}
